/**
 * Konsept sayfaları için mock veri. Sayılar prototip seed'inden ve
 * spec külliyatından (E-01, E-05, 03- kararları) türetildi; gerçek DB yok.
 */
import { cevir } from "@/lib/dil";

export type StationCode =
  | "S1" | "S2" | "S3" | "S4" | "S5" | "S6"
  | "S7" | "S8" | "S9" | "S10" | "S11" | "SERT";

export const STATIONS: { code: StationCode; ad: string; kisa: string; faz: string }[] = [
  { code: "S1", ad: cevir("Receiving"), kisa: cevir("Receiving"), faz: cevir("Phase 0") },
  { code: "S2", ad: cevir("Disassembly"), kisa: cevir("Disassembly"), faz: cevir("Phase 1") },
  { code: "S3", ad: cevir("Washing / Sand blasting"), kisa: cevir("Sand blasting"), faz: cevir("Phase 1") },
  { code: "S4", ad: cevir("Inspection"), kisa: cevir("Inspection"), faz: cevir("Phase 2") },
  { code: "S5", ad: "Disposition", kisa: "Dispo.", faz: cevir("Phase 2") },
  { code: "S6", ad: cevir("Repair Cycle"), kisa: cevir("Repair"), faz: cevir("Phase 3") },
  { code: "S7", ad: cevir("Hydrotest"), kisa: cevir("Hydrotest"), faz: cevir("Phase 4") },
  { code: "S8", ad: "Coating", kisa: "Coating", faz: cevir("Phase 5") },
  { code: "S9", ad: cevir("Set Gate"), kisa: "Set 5/5", faz: cevir("Phase 5") },
  { code: "S10", ad: cevir("Assembly"), kisa: cevir("Assembly"), faz: cevir("Phase 5") },
  { code: "S11", ad: cevir("Delivery"), kisa: cevir("Delivery"), faz: cevir("Phase 6") },
  { code: "SERT", ad: "Sertifikasyon", kisa: "DNV / COC", faz: "Paralel" },
];

export const BATCHES = [
  { no: "B1", riser: 38, teslim: 38, wo: "452909" },
  { no: "B2", riser: 12, teslim: 12, wo: "452909A" },
  { no: "B3", riser: 35, teslim: 35, wo: "453228" },
  { no: "B4", riser: 33, teslim: 8, wo: "—" },
];

/** İstasyon × batch: komponent sayıları (5 hat × riser). Sıra STATIONS ile aynı. */
export const STATION_BATCH: Record<string, number[]> = {
  B1: [0, 0, 0, 4, 9, 22, 31, 40, 24, 30, 30, 0],
  B2: [0, 0, 5, 9, 12, 14, 8, 6, 3, 3, 0, 0],
  B3: [0, 18, 41, 52, 36, 20, 8, 0, 0, 0, 0, 0],
  B4: [25, 15, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
};

export const KPIS = [
  { key: "kapsam", ad: cevir("Scope"), deger: "85", alt: "/ 175 riser", not: cevir("active cycle 2024–29"), ton: "neutral" },
  { key: "islemde", ad: cevir("In progress"), deger: "148", alt: "components", not: cevir("of 425"), ton: "info" },
  { key: "hold", ad: cevir("Open hold"), deger: "6", alt: cevir("Awaiting G1"), not: cevir("oldest 2 d 4 h"), ton: "hold" },
  { key: "dispo", ad: cevir("Awaiting Disposition"), deger: "11", alt: "items", not: cevir("oldest 19 days"), ton: "warn" },
  { key: "gecikmis", ad: cevir("Overdue pipe"), deger: "17", alt: cevir("above p85"), not: cevir("S3 and S8 heavy"), ton: "bad" },
  { key: "ret", ad: cevir("Riser with reject Items"), deger: "14", alt: "riser", not: cevir("15 of 38 decisions"), ton: "neutral" },
  { key: "dokuman", ad: cevir("Missing document"), deger: "9", alt: "MRB", not: cevir("166 / 175 received"), ton: "warn" },
  { key: "moc", ad: cevir("extended by MOC"), deger: "3", alt: "riser", not: cevir("counter running"), ton: "neutral" },
  { key: "set", ad: cevir("Blocked set"), deger: "4", alt: "riser", not: cevir("3 are spare parts"), ton: "bad" },
  { key: "teslim", ad: cevir("Delivery / COC"), deger: "43", alt: "/ 3 COC", not: cevir("43 ↔ 45 reconciliation open"), ton: "ok" },
] as const;

export type BlokeKodu =
  | "DISPOSITION-BEKLIYOR"
  | "YEDEK-PARCA"
  | "FOUND-CONDITION"
  | "DOKUMAN-EKSIK"
  | "SERTIFIKA/KALIBRASYON"
  | "SET-BEKLIYOR"
  | "KIMLIK-DOGRULAMA";

export const BLOKE_LABEL: Record<BlokeKodu, string> = {
  "DISPOSITION-BEKLIYOR": cevir("Awaiting OSI disposition"),
  "YEDEK-PARCA": cevir("Spare part"),
  "FOUND-CONDITION": "Found condition",
  "DOKUMAN-EKSIK": cevir("Missing document"),
  "SERTIFIKA/KALIBRASYON": cevir("Calibration"),
  "SET-BEKLIYOR": "Set 4/5",
  "KIMLIK-DOGRULAMA": cevir("Identity"),
};

export type RiserRow = {
  rn: string;
  sn: string;
  batch: string;
  istasyon: StationCode;
  darbogaz: string; // hangi hat
  gun: number;
  bloke?: BlokeKodu;
  bekleyen?: string;
  hatlar: { hat: "MB" | "C" | "K" | "B" | "H"; istasyon: StationCode; durum: "ok" | "islemde" | "bloke" | "hold" | "na" }[];
};

export const RISERS: RiserRow[] = [
  {
    rn: "R061", sn: "1307323-1", batch: "B1", istasyon: "S6", darbogaz: "MB", gun: 23,
    bloke: "YEDEK-PARCA", bekleyen: "MT box connector · PN 56026001123",
    hatlar: [
      { hat: "MB", istasyon: "S6", durum: "bloke" },
      { hat: "C", istasyon: "S8", durum: "ok" },
      { hat: "K", istasyon: "S8", durum: "ok" },
      { hat: "B", istasyon: "S8", durum: "ok" },
      { hat: "H", istasyon: "S9", durum: "ok" },
    ],
  },
  {
    rn: "R107", sn: "1306721-1", batch: "B1", istasyon: "S6", darbogaz: "MB", gun: 9,
    hatlar: [
      { hat: "MB", istasyon: "S6", durum: "islemde" },
      { hat: "C", istasyon: "S7", durum: "islemde" },
      { hat: "K", istasyon: "S7", durum: "ok" },
      { hat: "B", istasyon: "S7", durum: "ok" },
      { hat: "H", istasyon: "S9", durum: "ok" },
    ],
  },
  {
    rn: "R111", sn: "1306716-1", batch: "B1", istasyon: "S6", darbogaz: "MB", gun: 14,
    bloke: "FOUND-CONDITION", bekleyen: cevir("finding after 15.5 m cut · reported to OSI"),
    hatlar: [
      { hat: "MB", istasyon: "S6", durum: "bloke" },
      { hat: "C", istasyon: "S8", durum: "ok" },
      { hat: "K", istasyon: "S8", durum: "ok" },
      { hat: "B", istasyon: "S8", durum: "ok" },
      { hat: "H", istasyon: "S9", durum: "ok" },
    ],
  },
  {
    rn: "R117", sn: "1281597-1", batch: "B1", istasyon: "S5", darbogaz: "K", gun: 19,
    bloke: "DISPOSITION-BEKLIYOR", bekleyen: cevir("Kill pin · SURVREP sent 05.08"),
    hatlar: [
      { hat: "MB", istasyon: "S8", durum: "ok" },
      { hat: "C", istasyon: "S8", durum: "ok" },
      { hat: "K", istasyon: "S5", durum: "bloke" },
      { hat: "B", istasyon: "S8", durum: "ok" },
      { hat: "H", istasyon: "S9", durum: "ok" },
    ],
  },
  {
    rn: "R025", sn: "1309840-9", batch: "B2", istasyon: "S6", darbogaz: "B", gun: 6,
    hatlar: [
      { hat: "MB", istasyon: "S6", durum: "islemde" },
      { hat: "C", istasyon: "S7", durum: "ok" },
      { hat: "K", istasyon: "S6", durum: "hold" },
      { hat: "B", istasyon: "S6", durum: "islemde" },
      { hat: "H", istasyon: "S6", durum: "islemde" },
    ],
  },
  {
    rn: "R034", sn: "1307190-2", batch: "B2", istasyon: "S6", darbogaz: "B", gun: 4,
    hatlar: [
      { hat: "MB", istasyon: "S8", durum: "ok" },
      { hat: "C", istasyon: "S8", durum: "ok" },
      { hat: "K", istasyon: "S8", durum: "ok" },
      { hat: "B", istasyon: "S6", durum: "hold" },
      { hat: "H", istasyon: "S9", durum: "ok" },
    ],
  },
  {
    rn: "R046", sn: "1265390-1", batch: "B2", istasyon: "S9", darbogaz: "K", gun: 11,
    bloke: "SET-BEKLIYOR", bekleyen: cevir("Kill pin connector · ordered 12.08"),
    hatlar: [
      { hat: "MB", istasyon: "S9", durum: "ok" },
      { hat: "C", istasyon: "S9", durum: "ok" },
      { hat: "K", istasyon: "S6", durum: "bloke" },
      { hat: "B", istasyon: "S9", durum: "ok" },
      { hat: "H", istasyon: "S9", durum: "ok" },
    ],
  },
  {
    rn: "R142", sn: "—", batch: "B3", istasyon: "S3", darbogaz: "MB", gun: 8,
    hatlar: [
      { hat: "MB", istasyon: "S3", durum: "islemde" },
      { hat: "C", istasyon: "S3", durum: "islemde" },
      { hat: "K", istasyon: "S3", durum: "islemde" },
      { hat: "B", istasyon: "S3", durum: "islemde" },
      { hat: "H", istasyon: "S4", durum: "ok" },
    ],
  },
  {
    rn: "R157", sn: "BM-8841", batch: "B3", istasyon: "S2", darbogaz: "—", gun: 2,
    bloke: "KIMLIK-DOGRULAMA", bekleyen: cevir("Assembly SN not found in MRB · ex-Transocean"),
    hatlar: [
      { hat: "MB", istasyon: "S2", durum: "bloke" },
      { hat: "C", istasyon: "S2", durum: "bloke" },
      { hat: "K", istasyon: "S2", durum: "bloke" },
      { hat: "B", istasyon: "S2", durum: "bloke" },
      { hat: "H", istasyon: "S2", durum: "bloke" },
    ],
  },
  {
    rn: "R159", sn: "1306735-1", batch: "B3", istasyon: "S4", darbogaz: "C", gun: 5,
    hatlar: [
      { hat: "MB", istasyon: "S4", durum: "islemde" },
      { hat: "C", istasyon: "S4", durum: "islemde" },
      { hat: "K", istasyon: "S4", durum: "islemde" },
      { hat: "B", istasyon: "S4", durum: "ok" },
      { hat: "H", istasyon: "S4", durum: "ok" },
    ],
  },
  {
    rn: "R167", sn: "—", batch: "B4", istasyon: "S1", darbogaz: "—", gun: 1,
    hatlar: [
      { hat: "MB", istasyon: "S1", durum: "islemde" },
      { hat: "C", istasyon: "S1", durum: "islemde" },
      { hat: "K", istasyon: "S1", durum: "islemde" },
      { hat: "B", istasyon: "S1", durum: "islemde" },
      { hat: "H", istasyon: "S1", durum: "islemde" },
    ],
  },
  {
    rn: "R106", sn: "1306721-9", batch: "B1", istasyon: "SERT", darbogaz: "—", gun: 61,
    bloke: "DOKUMAN-EKSIK", bekleyen: cevir("Hydraulic test gasket CoC · DNV VerCom open"),
    hatlar: [
      { hat: "MB", istasyon: "S11", durum: "ok" },
      { hat: "C", istasyon: "S11", durum: "ok" },
      { hat: "K", istasyon: "S11", durum: "ok" },
      { hat: "B", istasyon: "S11", durum: "ok" },
      { hat: "H", istasyon: "S11", durum: "ok" },
    ],
  },
];

export const ROLES = [
  { id: "bahadir", ad: "Bahadır Gerez", rol: cevir("Project Manager"), kisa: "PM" },
  { id: "mustafa", ad: "Mustafa Ali Hançar", rol: cevir("Quality Lead"), kisa: "QA/QC" },
  { id: "erdem", ad: "Erdem Ulu", rol: cevir("Field Inspector"), kisa: "QC" },
  { id: "mutlu", ad: "Mutlu Tıpırdamaz", rol: cevir("Foreman / Welding"), kisa: cevir("Foreman") },
  { id: "ensari", ad: "Ensari İpek", rol: cevir("Field Supervisor"), kisa: cevir("Field") },
];

export type QueueItem = {
  id: string;
  baslik: string;
  alt: string;
  tip: "onay" | "yukle" | "kayit" | "karar";
  kapi?: string;
  yas: string;
  acil?: boolean;
};

export const MY_QUEUE: QueueItem[] = [
  { id: "q1", baslik: cevir("Fit-up approval · R025 Kill · W-25069-0041"), alt: cevir("Foreman said “We are ready” · WPS W-00313 rev 2"), tip: "onay", kapi: "G1", yas: "2 s", acil: true },
  { id: "q2", baslik: cevir("Upload NDT report · R034 Booster"), alt: cevir("UT+MT + 3 Hardness values · post-PWHT"), tip: "yukle", kapi: "Duvar 7", yas: "1 g" },
  { id: "q3", baslik: cevir("Verify Disposition · R117"), alt: cevir("OSI report arrived · 4 Items waiting for ST suggestion"), tip: "karar", kapi: "G3", yas: "3 s", acil: true },
  { id: "q4", baslik: cevir("Upload SURVREP · R159"), alt: cevir("Return from Sand blasting confirmed · Ensari · 16.08"), tip: "yukle", yas: "5 g" },
  { id: "q5", baslik: cevir("Disassembly closure · R157"), alt: cevir("Waiting for signed FM-0011 scan · 21/21 rows"), tip: "kayit", kapi: "G1", yas: "2 g" },
  { id: "q6", baslik: cevir("Verification queue · 3 Items"), alt: cevir("Below threshold OCR: heat no ×2, lot no ×1"), tip: "karar", yas: "6 s" },
];

export const AGING = [
  // istasyon index (0..11), gün, tür
  { s: 2, g: 3 }, { s: 2, g: 11 }, { s: 2, g: 19 }, { s: 2, g: 27, late: true },
  { s: 3, g: 2 }, { s: 3, g: 4 }, { s: 3, g: 6 }, { s: 3, g: 9 },
  { s: 4, g: 7 }, { s: 4, g: 12 }, { s: 4, g: 19, late: true }, { s: 4, g: 24, late: true },
  { s: 5, g: 5 }, { s: 5, g: 14 }, { s: 5, g: 23, late: true }, { s: 5, g: 9 },
  { s: 6, g: 3 }, { s: 6, g: 8 }, { s: 6, g: 15 }, { s: 6, g: 40, late: true },
  { s: 7, g: 4 }, { s: 7, g: 16 }, { s: 7, g: 29, late: true }, { s: 7, g: 33, late: true },
  { s: 8, g: 11, late: true }, { s: 8, g: 6 }, { s: 9, g: 2 }, { s: 10, g: 3 },
  { s: 11, g: 61, late: true }, { s: 11, g: 40 }, { s: 11, g: 22 },
];

export const P85: Record<number, number> = { 2: 18, 3: 8, 4: 15, 5: 14, 6: 30, 7: 21, 8: 10, 9: 5, 10: 6, 11: 45 };

export const OLAYLAR = [
  { ts: "14:32", kim: "Erdem Ulu", ne: cevir("R034 Booster · NDT+Hardness report uploaded, Accept"), tip: "kayit" },
  { ts: "13:50", kim: cevir("System"), ne: cevir("R117 Disposition SLA exceeded 14 days → escalation to PM"), tip: "sistem" },
  { ts: "11:05", kim: "Mutlu Tıpırdamaz", ne: cevir("R025 Kill · fit-up preparation: “We are ready, call quality control”"), tip: "kayit" },
  { ts: "09:41", kim: "Ensari İpek", ne: cevir("R159 · return from Sand blasting confirmation"), tip: "kayit" },
  { ts: "09:12", kim: "Mustafa Ali Hançar", ne: cevir("VerCom Rev 14 uploaded · 25 open / 13 closed"), tip: "yukle" },
  { ts: "yesterday", kim: cevir("System"), ne: cevir("R046 set 4/5 → SET-WAITING (waiting for Kill pin)"), tip: "sistem" },
];

export const HIDRO = { done: 299, pending: 32, red: 9 };
export const DNV = { acik: 25, toplam: 38 };
